module.exports = __webpack_public_path__ + "img/Xiao-Feng Zheng.15797351.jpg";